import AliyunOss from './AliyunOss'
import { message } from 'ant-design-vue'
import store from '../store'
import { generateUUID } from '@/utils/index'
import axios from 'axios'
import qs from 'qs'
import { generalUploadFile } from '@/utils/AliyunOss2'

export default {
  generalUploadFile,
  /**
   * 上传学生作答媒体文件
   * @param buffer buffer数组
   * @param recordId 评测录音id
   * @param fileExtension 文件后缀名
   * @param timeout 超时时间，默认 60000 毫秒，即 60 秒
   * @returns {Promise<{res: {status: number}, url: string}|*>}
   */
  uploadMediaFile: async ({ buffer, recordId, fileExtension = 'wav', timeout = 60000 }) => {
    // 是否弱网络
    const isWeakNetwork = sessionStorage.getItem('isWeakNetwork') || false
    // const filePath = `answer/${id}.wav`
    const userId = store.getters.userId
    const filePath = userId.substring(0, 4) + '/' + generateUUID() + (fileExtension ? `.${fileExtension}` : '')
    // 特殊学校，直接使用分片上传
    if (
      process.env.VUE_APP_MULTIPART_SCHOOL &&
      JSON.parse(process.env.VUE_APP_MULTIPART_SCHOOL)[store.getters.userInfo.schoolId]
    ) {
      const data = JSON.parse(process.env.VUE_APP_MULTIPART_SCHOOL)[store.getters.userInfo.schoolId]
      // 如果是异步上传，直接返回
      if (data.asyncUpload) {
        return {
          res: { status: 200 },
          url: ''
        }
      }
      try {
        return await AliyunOss.multipartUploadFile(
          filePath,
          buffer,
          'answerMediaBucketName',
          data.timeout,
          data.parallel,
          data.partSize
        )
      } catch (e) {
        message.error('上传失败请检查网络设置')
        return e
      }
    }
    // 如果是弱网络，使用分片上传，否则使用完整上传
    if (isWeakNetwork) {
      try {
        return await AliyunOss.multipartUploadFile(filePath, buffer, 'answerMediaBucketName')
      } catch (e) {
        message.error('上传失败请检查网络设置')
        return e
      }
    }
    try {
      return await AliyunOss.putMediaFile(filePath, buffer, 'answerMediaBucketName')
    } catch (e) {
      console.log('完整上传文件失败，尝试使用分片上传')
      sessionStorage.setItem('isWeakNetwork', true)
      try {
        return await AliyunOss.multipartUploadFile(filePath, buffer, 'answerMediaBucketName')
      } catch (e) {
        message.error('上传失败请检查网络设置')
        return e
      }
    }
  },
  /**
   * 上传学生作答 info 数据
   * @param info info 数据
   * @param timeout 超时时间
   * @param needTransfer 是否需要做转存(先声测评audioUrl转阿里云地址)
   * @returns {Promise<*>}
   * 该存储桶内的文件 ObjectKey 规则如下: userId  +  "/" + 13位的毫秒时间戳 + ".info"
   * 例:  ce47c56df7ab4d09a3ab10ba0d935f74/1634288564397.info
   */
  uploadInfoFile: async (info, timeout = 60000, needTransfer = false) => {
    const userId = store.getters.userId
    const str = needTransfer ? 'temp-media/' : ''
    const filePath = str + userId + '/' + new Date().getTime() + '.info'
    try {
      return await AliyunOss.putInfoFile(filePath, JSON.stringify(info), 'answerInfoBucketName')
    } catch (e) {
      message.error('上传失败请检查网络设置')
      return e
    }
  },
  /**
   * 读取线上文件
   * @param url 线上文件地址
   * @returns {Promise<unknown>}
   */
  readFile: url => {
    return new Promise((resolve, reject) => {
      const Url = url.indexOf('http://') === 0 ? url.replace('http://', 'https://') : url
      axios({ url: Url })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /**
   * 解析url -- 根据参数名获取指定参数值
   * @param name 参数名
   * @returns {string|null}
   */
  getUrlParam: name => {
    // 由于路由模式不同（hash模式和history模式），在hash模式下由于域名后路径前会有一个#符，导致window.location.search获取不到url中参数字符，所以拿完整的url去截取字符串去获取参数
    const href = window.location.href // 获取url
    const index = href.indexOf('?')
    if (index === -1) return null // 如果url中没有传参直接返回空对象
    const search = href.slice(index + 1)
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    const r = search.match(reg)
    return r != null ? unescape(r[2]) : null
  },
  /**
   * 解析url -- 获取全部参数
   * @returns {{}}
   */
  getAllUrlParam: () => {
    // 由于路由模式不同（hash模式和history模式），在hash模式下由于域名后路径前会有一个#符，导致window.location.search获取不到url中参数字符，所以拿完整的url去截取字符串去获取参数
    // const aa = 'https://stg-aiclassroom.kaolayibai.com/silent-login?teacherId=33CFE6498CAF4F32B5F858EA8209FCA9&loginAuthToken=eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIzM0NGRTY0OThDQUY0RjMyQjVGODU4RUE4MjA5RkNBOSIsImp0aSI6ImNjOWQzNzc3LWQ1ZjMtNDMwMC04NGU1LTE0YzI3Y2RjM2UyMyIsImlhdCI6MTY4NDQ4MTI2N30.uSdocTLUmvcthOT9wCcHf1rLm5Pg4AbK3DvgQ4dcdcs&loginUdid=9vRAni6YHmaa62qcVT3BsForDkLkwEM7'
    // console.log(aa)
    const href = window.location.href // 获取url
    const index = href.indexOf('?')
    if (index === -1) return {} // 如果url中没有传参直接返回空对象
    const search = href.slice(index + 1)
    // console.log('解码前：', search)
    // console.log('解码后：', decodeURIComponent(search))
    const parseResult = qs.parse(search)
    const result = {}
    if (parseResult) {
      const entries = Object.entries(parseResult)
      for (const [key, value] of entries) {
        result[key] = decodeURIComponent(value)
      }
    }
    return result
  }
}
